import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { googleAuth } from "../api";
import { useDispatch } from "react-redux";
import { saveToken } from "../store/slice/userSlice";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { showNotification, GOOGLE_AUTH } from "../config";
import { ReactComponent as CallIcon } from "../inlineSvgs/call.svg";
import { ReactComponent as LogoIcon } from "../inlineSvgs/logo-red.svg";

const GoogleAuthPage = () => {
  const [displayForm, toggleForm] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      phone: "",
    },
  });

  const onSubmit = async (data) => {
    localStorage.setItem("GOOGLE_AUTH_Phone", "" + data.phone.replace(/[^+\d]/g, ""));
    window.location.replace(GOOGLE_AUTH);
  };

  useEffect(() => {
    const token = decodeURIComponent(location.search.split("=")[1]?.replace("&scope", "") ?? "");
    const phone = localStorage.getItem("GOOGLE_AUTH_Phone");
    const data = { token: token };

    if (phone) {
      data.phone = phone;
    }

    if (token) {
      googleAuth(data)
        .then((res) => {
          if (res.status === 200) {
            const token = res.data?.data?.access_token;
            if (token) {
              dispatch(saveToken(token));
              navigate("/");
            }
          }

          if (res.status === 204) {
            navigate("/verify-phone");
          }
        })
        .catch((err) => {
          if (err.response?.data?.emptyFields) {
            toggleForm(true);
          } else {
            showNotification(err.response?.data.detail ? err.response?.data.detail : "Something went wrong");

            // navigate("/login");
          }
        });
    }
  }, []);

  return (
    <div className="google-auth-page">
      {displayForm ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="logo">
            <LogoIcon />
          </div>
          <div className="title">Your phone number was not received from Google</div>
          <label htmlFor="phone">Please enter your phone number</label>
          <div className={errors.phone ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <CallIcon />
            </div>
            <input
              id="phone"
              type="tel"
              placeholder="Enter your phone number"
              {...register("phone", {
                required: { value: true, message: "This is required field" },
              })}
            />
            {errors.phone && <p className="errors">{errors.phone.message}</p>}
          </div>

          <button type="submit" className="beauty-btn fill">
            Submit
          </button>

          <div className="delimiter">or</div>

          <Link className="back-link" to="/login">
            Back to Log In page
          </Link>
        </form>
      ) : (
        <svg className="gear-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
          <path
            fill="#BF295C"
            stroke="#BF295C"
            stroke-width="13"
            transform-origin="center"
            d="m148 84.7 13.8-8-10-17.3-13.8 8a50 50 0 0 0-27.4-15.9v-16h-20v16A50 50 0 0 0 63 67.4l-13.8-8-10 17.3 13.8 8a50 50 0 0 0 0 31.7l-13.8 8 10 17.3 13.8-8a50 50 0 0 0 27.5 15.9v16h20v-16a50 50 0 0 0 27.4-15.9l13.8 8 10-17.3-13.8-8a50 50 0 0 0 0-31.7Zm-47.5 50.8a35 35 0 1 1 0-70 35 35 0 0 1 0 70Z"
          >
            <animateTransform
              type="rotate"
              attributeName="transform"
              calcMode="spline"
              dur="2"
              values="0;120"
              keyTimes="0;1"
              keySplines="0 0 1 1"
              repeatCount="indefinite"
            ></animateTransform>
          </path>
        </svg>
      )}
    </div>
  );
};

export default GoogleAuthPage;
